<template>
  <JyPagebody :activatedLoad="reloadData">
    <TemplateList title="链接管理" :activatedLoad="reloadData" :hasFooter="false" lock-mode="grid">
      <template v-slot:searchBar>
        <div class="mb-1 ml-md-2">
          <JyButton v-if="hasPermiss('web.links.add')" type="primary" @click="addRoot" is-outline>添加链接</JyButton>
        </div>
        <div class="mb-1 ml-md-2">
          <JyButton type="success" icon="refresh" title="刷新" @click="loadList" is-outline></JyButton>&nbsp;
        </div>
        <div class="mb-1 ml-md-2">
          <el-select v-model="searchData.cateid" size="small" filterable clearable placeholder="搜索：链接类别">
            <el-option v-for="(v, k) in linkstype" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </div>
        <div class="mb-1 ml-md-2">
          <el-input v-model.lazy="searchData.name" size="small" placeholder="搜索：链接名称" style="width:10rem" clearable></el-input>
        </div>
      </template>
      <el-form slot="grid" label-width="0" :rules="rules" :model="editData" size="small" ref="editForm" class="h-100 bg-white activity-cate-form">
        <el-table
          ref="grid"
          v-loading="loadedData" loading-text="努力加载中..."
          :data="tableData"
          style="width: 100%; height:100%"
          height="100%"
          row-key="id"
          :row-class-name="editRowClass"
          border stripe
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column
            prop="name"
            label="名称"
            width="180">
            <template v-slot="{row, $index}">
              <el-row type="flex" class="flex-wrap">
                <form-item v-if="$index == editIndex" label="" prop="name" fill="4">
                  <el-input v-model="editData.name"></el-input>
                </form-item>
                <div v-else>{{ row.name }}</div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            prop="cateid"
            label="类别"
            width="180">
            <template v-slot="{row, $index}">
              <el-row type="flex" class="flex-wrap">
                <form-item v-if="$index == editIndex" label="" prop="cateid" fill="4">
                  <el-select v-model="editData.cateid" filterable clearable>
                    <el-option v-for="(v, k) in linkstype" :key="k" :label="v" :value="k"></el-option>
                  </el-select>
                </form-item>
                <div v-else>{{ linkstype[row.cateid] || row.cateid }}</div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            prop="icon"
            label="ICON"
            width="180">
            <template v-slot="{row, $index}">
              <el-row type="flex" class="flex-wrap">
                <form-item v-if="$index == editIndex" label="" prop="icon" fill="4">
                  <el-upload
                    class="upload-demo"
                    :action="uploadPic"
                    :headers="headers"
                    :on-success="handleSuccess0">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    <div v-if="editData.icon">
                      <img :src="rootPath + editData.icon" style="height:2rem;">
                      <a href="javascript:;" class="text-danger" @click.stop="removeIcon">删除</a>
                    </div>
                  </el-upload>
                </form-item>
                <div v-else><img v-if="row.icon" :src="rootPath + row.icon" style="height:3rem;"></div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            prop="logo"
            width="200"
            label="LOGO">
            <template v-slot="{row, $index}">
              <el-row type="flex" class="flex-wrap">
                <form-item v-if="$index == editIndex" label="" prop="logo" fill="4">
                  <el-upload
                    class="upload-demo"
                    :action="uploadPic"
                    :headers="headers"
                    :on-success="handleSuccess">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    <div v-if="editData.logo">
                      <img :src="rootPath + editData.logo" style="height:2rem;">
                      <a href="javascript:;" class="text-danger" @click.stop="removeLogo">删除</a>
                    </div>
                  </el-upload>
                </form-item>
                <div v-else><img v-if="row.logo" :src="rootPath + row.logo" style="height:3rem;"></div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            prop="url"
            width="200"
            label="跳转链接">
            <template v-slot="{row, $index}">
              <el-row type="flex" class="flex-wrap">
                <form-item v-if="$index == editIndex" label="" prop="url" fill="4">
                  <el-input v-model="editData.url"></el-input>
                </form-item>
                <div v-else>{{ row.url }}</div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template v-slot:header>
              操作
              <a href="javascript:;" @click="addRoot">添加链接</a>
            </template>
            <template v-slot="{row, $index}">
              <JyButton v-if="$index != editIndex && hasPermiss('web.links.edit')" type="primary" size="sm" @click="doEdit(row, $index)">编辑</JyButton>
              <JyButton v-if="$index == editIndex" type="success" size="sm" is-outline :is-loading="row.saveLoading" @click="doUpdate(row, $index)">保存</JyButton>
              <JyButton v-if="$index == editIndex" type="danger" size="sm" is-outline class="ml-1" @click="doCancel(row, $index)">取消</JyButton>
              <JyButton v-if="$index != editIndex && hasPermiss('web.links.del')" type="danger" size="sm" is-outline class="ml-1" @click="doDel(row, $index)">删除</JyButton>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </TemplateList>
  </JyPagebody>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import Sortable from 'sortablejs';
import tools from 'jyutils/tools';
import list from '../mixin/list';
import { generateId } from 'jyutils/utils';
import TemplateList from '../template-list.vue';
export default {
  components: { TemplateList },
  mixins: [tools, list],
  data() {
    return {
      title:'友情链接管理',
      searchData: {name:null, cateid:null},
      editIndex: -1,
      rules: {
        name: {required: true, message:'名称必填！'},
        cateid: {required: true, message:'请选择类别！'},
      }
    }
  },
  computed: {
    ...mapGetters({
      linkstype: [types.STATUS.linkstype]
    }),
    tableData() {
      const name = this.searchData.name;
      const cateid = this.searchData.cateid;
      return this.list.filter(d => {
        return (name ? d.indexOf(d.name) > -1 : true) && (cateid ? d.cateid == cateid : true);
      });
    },
    listUrl() {
      return 'sys/links';
    },
    defaultData() {
      return {id:null, name: null, icon:null, logo:null, cateid:null, seq:null, url:null};
    }
  },
  watch: {
  },
  mounted () {
    this.$nextTick(() => {
      this.rowDrop();
    });
  },
  methods: {
    listOkcb(json) {
      this.list = json;
      this.editIndex = -1;
    },
    reloadData() {
      if (!this.list || !this.list.length) {
        this.loadList();
      }
      if (!this.linkstype || !Object.keys(this.linkstype).length) {
        this.$store.dispatch(types.STATUS.linkstype);
      }
    },
    editRowClass({rowIndex}) {
      return this.editIndex == rowIndex ? 'edit_table_row' : '';
    },
    doEdit(data, index) {
      this.editData = Object.assign({}, data);
      this.editIndex = index;
    },
    doUpdate(data, index) {
      this.submitform().then(() => {
        let changeData = JSON.stringify(this.editData), _data = JSON.stringify(data);
        if (changeData != _data) {
          this.$set(data, 'saveLoading', true);
          let postData = {};
          Object.assign(postData, this.editData);
          // 如果是新加
          if (postData.id.startWith('_temp')) {
            postData.id = null;
          }
          // update to server
          this.doPost({
            url: 'sys/links/save',
            data: postData,
            okcb: (json) => {
              this.editIndex = -1;
              Object.assign(data, json);
            },
            cb: () => {
              this.$delete(data, 'saveLoading');
            }
          })
        } else {
          this.doCancel(data, index);
        }
      })
      .catch(() => {
        
      });
    },
    doCancel(data, index) {
      if (data.id.startWith('_temp')) {
        this.list.splice(index, 1);
        this.updateEditIndex(index);
      } else {
        this.editIndex = -1;
      }
    },
    doDel(data, index) {
      let cb = () => {
        if (data.id.startWith('_temp')) {
          this.doCancel(data, index);
        } else {
          this.doPost({
            url: 'sys/links/del/'+ data.id,
            okcb: () => {
              this.$message.success('删除成功!');
              this.list.splice(index, 1);
              this.updateEditIndex(index);
            }
          });
        }
      }
      this.msgbox('此操作将永久删除该信息, 是否继续?', () => {
        cb();
      });
    },
    updateEditIndex(index) {
      if (index == this.editIndex) {
        this.editIndex = -1;
      } else if (index < this.editIndex) {
        this.editIndex -= 1;
      }
    },
    removeIcon() {
      this.msgbox('确定要删除该icon吗？', () => {
        this.editData.icon = null;
      });
    },
    removeLogo() {
      this.msgbox('确定要删除该Logo吗？', () => {
        this.editData.logo = null;
      });
    },
    handleSuccess0(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.editData.icon = res.obj.pic;
        filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    handleSuccess(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.editData.logo = res.obj.pic;
        filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    addRoot() {
      let data = Object.assign({}, this.defaultData, {id: `_temp${generateId()}`});
      this.list.unshift(data);
      this.editData = Object.assign({}, data);
      this.editIndex = 0;
    },
    // 保存顺序
    saveOrder() {
      this.loadedData = true;
      this.doPost({
        url: 'sys/links/saveSeq',
        data: this.list,
        okcb: () => {
          this.$message.success('排序成功!');
        },
        cb: () => {
          this.loadedData = false;
        }
      });
    },
    // 行拖动排序
    rowDrop() {
      const tbody = this.$refs.grid.$el.querySelector('.el-table__body-wrapper tbody');
      const _this = this
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          // console.log(currRow)
          _this.tableData.splice(newIndex, 0, currRow);

          // 保存顺序
          _this.saveOrder();
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.news-cate-form {
  .eg-icon {
    .flex-center();
    width:2.6rem;
    height:2.6rem;
    border-radius:50%;
    i {
      color:#fff;
    }
  }
  .upload-demo {
    width:100%;
    /deep/ .el-upload-list__item-name {
      width:130px;
    }
  }
}
</style>
